import forEach from "lodash/forEach";
import isEmpty from "lodash/isEmpty";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { SidebarMenuList } from "Areas/Sidebar/Common";
import buildMethodSidebarItems from "Areas/Sidebar/DocumentsFloat/utils/buildMethodSidebarItems";
import buildRunMethodsError from "Areas/Sidebar/DocumentsFloat/utils/buildRunMethodsError";
import MethodsBottomPanel from "./methodsBottomPanel";
import locale from "./tabMethods.locale";
import styles from "./tabMethods.module.css";
import { Divider } from "Components/Divider";
import TextWidget from "Components/optionForm/widgets/textWidget";
import classNames from "classnames";
const onItemClick = (item) => {
    item.onItemClick && item.onItemClick();
};
const filterButtons = [
    {
        location: "after",
        name: "settings-button",
        options: {
            icon: "icon-search-glass text-light-on-surface-variant icon-color-inherit font-bold font-h5",
            elementAttr: {
                class: classNames(styles["filter-icon"], "no-border bg-transparent p-0")
            },
            disabled: true,
            height: 32,
            width: 32
        }
    }
];
export default function TabMethods(props) {
    const popoverRefs = useRef({});
    const [filteredText, setFilteredText] = useState();
    useEffect(() => {
        if (props.methodsPanelRef) {
            props.methodsPanelRef.current = {
                hideConfirmations: () => {
                    forEach(popoverRefs.current, popover => {
                        var _a;
                        try {
                            if ((_a = popover.current) === null || _a === void 0 ? void 0 : _a.instance.element().isConnected)
                                popover.current.instance.hide();
                        }
                        catch (ex) {
                            console.warn(ex);
                        }
                    });
                }
            };
        }
    }, []);
    useEffect(() => {
        props.onInitialized && props.onInitialized();
    }, []);
    const handleRunMethods = useCallback((documentId, data) => {
        if (!props.documentObjects || !props.activeDocumentType)
            return;
        props.onBeforeRunMethods && props.onBeforeRunMethods();
        const invalidMessage = buildRunMethodsError(props.documentObjects, data);
        if (!invalidMessage) {
            props.onRunMethods && props.onRunMethods(documentId, props.activeDocumentType, data);
        }
        else {
            props.showError && props.showError(invalidMessage);
        }
    }, [
        props.onBeforeRunMethods,
        props.onRunMethods,
        props.documentObjects,
        props.activeDocumentType,
        props.showError
    ]);
    const sidebarMenuItems = useMemo(() => {
        popoverRefs.current = {};
        return props.availableMethods &&
            props.availableMethodsMap &&
            props.selectedNodesSource &&
            props.documentObjects
            ? buildMethodSidebarItems(props.availableMethods, props.availableMethodsMap, props.selectedNodesSource, props.showHints, props.readOnlyMode, popoverRefs, props.canRunMethods && props.canAddToQueue
                ? (method, nodesSource) => {
                    props.onSetMethodSelected && props.onSetMethodSelected(method, nodesSource, true);
                }
                : undefined, props.canRunMethods
                ? (method, nodesSource) => {
                    props.activeDocumentId &&
                        handleRunMethods(props.activeDocumentId, [{ method, nodesSource }]);
                }
                : undefined, props.runOnItemClick)
            : undefined;
    }, [
        props.documentObjects,
        props.canRunMethods,
        props.canAddToQueue,
        props.readOnlyMode,
        props.availableMethods,
        props.availableMethodsMap,
        props.selectedNodesSource,
        props.showHints,
        props.canAddToQueue,
        props.activeDocumentId,
        props.activeDocumentType,
        props.onSetMethodSelected,
        props.runOnItemClick,
        handleRunMethods
    ]);
    const emptyText = isEmpty(props.selectedNodesSource)
        ? locale.SELECT_OBJECT
        : isEmpty(props.availableMethods)
            ? locale.NO_AVAILABLE_METHODS
            : "";
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles["search-panel"] },
            React.createElement(TextWidget, { value: filteredText, onChange: setFilteredText, label: "\u041F\u043E\u0438\u0441\u043A", labelMode: "floating", height: 44, buttons: filterButtons })),
        React.createElement("div", { className: styles.methods },
            React.createElement(SidebarMenuList, { colorDefault: props.colorDefault, colorHover: props.colorHover, colorActive: props.colorActive, bgColorDefault: props.bgColorDefault, bgColorActive: props.bgColorActive, actionIconColor: props.actionIconColor, hasOutsideIndents: props.hasOutsideIndents, inProgress: props.inProgress, sidebarMenuItems: sidebarMenuItems, emptyText: emptyText, filterText: filteredText, sortBy: props.sortBy, sortOrder: props.sortOrder, onItemClick: onItemClick, margin: true, className: styles.list })),
        React.createElement(Divider, null),
        React.createElement("div", null, props.canAddToQueue && props.canRunMethods && (React.createElement(MethodsBottomPanel, { menuExpanded: props.isExpanded, menuExpandedHeight: "calc(100dvh - 24px)", activeDocumentId: props.activeDocumentId, onRunMethods: handleRunMethods, onSetMethodSelected: props.onSetMethodSelected })))));
}
TabMethods.defaultProps = {
    canAddToQueue: true,
    showHints: true,
    hasOutsideIndents: true
};
